import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum ScheduleDemoButtonLocation {
  PERSONALIZED_SHIPPING = "PERSONALIZED_SHIPPING",
  DYNAMIC_SHIPPING = "DYNAMIC_SHIPPING",
  SEGMENTATION = "SEGMENTATION",
  CHECKOUT_UPSELL = "CHECKOUT_UPSELL",
  POST_PURCHASE_UPSELL = "POST_PURCHASE_UPSELL",
  CHECKOUT_PROBABILITY = "CHECKOUT_PROBABILITY",
  CHECKOUT_INSIGHTS = "CHECKOUT_INSIGHTS",
}

const COLT_SCHEDULE_DEMO_DESTINATION_URL =
  "https://calendly.com/cameron-buford-getredo/30min";
const PRESTON_SCHEDULE_DEMO_DESTINATION_URL =
  "https://calendly.com/preston-getredo/30min";

export function getScheduleDemoDestinationUrl() {
  // Flip a coin to decide which URL to use
  return Math.random() < 0.5
    ? COLT_SCHEDULE_DEMO_DESTINATION_URL
    : PRESTON_SCHEDULE_DEMO_DESTINATION_URL;
}

export const sendScheduleDemoClickedNotification = {
  name: "sendScheduleDemoClickedNotification" as const,
  input: z.object({
    source: createEnum(ScheduleDemoButtonLocation),
    calendarUrl: z.string(),
  }),
  output: z.null(),
};
